<div class="wrapper">
  @if (hasRelevantAction) {
    <button
      mat-icon-button
      class="toggle-button"
      [class.active]="isContentShowing"
      (click)="toggleContent(); $event.stopPropagation()"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  }

  @if (isContentShowing) {
    <div
      class="content"
      [forbidTrigger]="!isContentShowing"
      (appClickOutside)="toggleContent()"
      @smoothShowHideHeight
    >
      @for (action of actionsList; track $index) {
        @if (getLabelByAction(action)) {
          <button
            mat-button
            (click)="handleActionClick(action)"
          >
            {{ getLabelByAction(action) }}
          </button>
        }
      }
    </div>
  }
</div>
